exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shopify-collection-card>.image-container{padding-bottom:100%;margin-bottom:0;position:relative;border-radius:5px;background:#383838}[data-theme=dark] .shopify-collection-card>.image-container{background:#fff}.shopify-collection-card img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;border-radius:5px;position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b0ebc2f0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/shopify/shopifyCollectionCard.vue
// module id = BbYM
// module chunks = 1 38 54